enum PATH {
  BASE = '/',
  PRODUCTS = '/products',
  RESOURCES = '/resources',
  LOCATIONS = '/locations',
  SERVICES = '/services',
  CAREERS = '/careers',
  SUPPORT = '/support',
  // Client Menu
  REQUEST_A_SAMPLE = '/request-a-sample',
  HELP = '/help',
  CONTACT = '/contact',
  // Help Menu
  LISTS = '/lists',
  ACCOUNT = '/account',
  QUICK_ORDER = '/quick-order',
  CART = '/cart'
}

export default PATH;
